var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("chi-default-section", {
    staticClass: "menu--section-three_column",
    attrs: {
      menu: _vm.menu,
      section: _vm.section,
      "menu-version": _vm.menu.menu_version,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }